var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 5.33333C12.75 5.33333 11.5804 3.73979 10.6302 2.78898C9.68006 1.83816 8.36703 1.25 6.91663 1.25C4.01713 1.25 1.66663 3.6005 1.66663 6.5C1.66663 9.39949 4.01713 11.75 6.91663 11.75C9.3101 11.75 11.3295 10.1483 11.9614 7.95833M12.75 5.33333V1.83333M12.75 5.33333H9.24996",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/Refresh.55bd51c4d86cb2adb28d10f4909c2d56.svg";
export { ForwardRef as ReactComponent };